export default "/images/doge_environment__icon.png";